import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formStatus' })

export class FormStatusPipe implements PipeTransform {
    transform(status: number, isconditional?: boolean) {
        if (status == null) return '';

        switch (status) {
            case 0: return 'Unsaved Form';
            case 10: return 'Submitted / Awaiting Review';                    
            case 20: return 'On Waiting List';
            case 21: return 'On Waiting List';
            case 30: return `Application ${!!isconditional ? 'Conditionally ' : ''}Approved`;
            case 100: return 'Application Denied';
        }

        return ''+status;
    };
}